import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { t } = useLang();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    exchangeSession(sessionId)
      .then((user) => {
        setUser(user);
        toast.success(t("dl.welcome").replace("{name}", user.name || "hero"));
        navigate("/", { replace: true, state: { user } });
      })
      .catch(() => {
        toast.error(t("dl.loginFail"));
        navigate("/", { replace: true });
      });
  }, []);

  return null;
}
